import React from 'react';
import ScheduleContextMenu from './ScheduleContextMenu';
import ScheduleDeleteDialog from './ScheduleDeleteDialog';
import {
  GroupPasteOptionModal,
  GroupPastePreviewModal,
  GroupPasteResultModal,
  TrainerAssignConfirmModal,
} from './SchedulePasteDialogs';
import { TicketPeriodDialog } from '../privateLesson/ScheduleMoveConfirm';

/**
 * 복사·붙여넣기 UI 묶음(#143). useSchedulePaste 가 돌려준 객체를 그대로 넘기면 된다.
 * 화면마다 같은 메뉴·모달을 배선하지 않도록 한 곳에 모았다.
 * remove = useScheduleDelete 결과 — 넘기면 카드 메뉴에 '일정 삭제'와 확인 모달이 붙는다.
 */
const SchedulePasteLayer = ({ paste, remove }) => (
  <>
    <ScheduleContextMenu
      position={paste.menu?.position || null}
      mode={paste.menu?.mode}
      clipboardEntry={paste.clipboard}
      onCopy={paste.copy}
      onPaste={paste.paste}
      onDelete={remove ? () => remove.request(paste.menu?.event) : undefined}
      canCopy={paste.menu?.canCopy !== false}
      canDelete={!!paste.menu?.canDelete}
      onClose={paste.closeMenu}
    />
    {/* 복사할 날짜가 원본 예약 수강권 이용기간 밖 — 이동과 같은 팝업 */}
    <TicketPeriodDialog
      info={paste.periodAsk?.info}
      targetDate={paste.periodAsk?.targetDate}
      actionLabel="복사할 수 없습니다"
      onClose={paste.closePeriodAsk}
    />
    {remove && (
      <ScheduleDeleteDialog target={remove.target} busy={remove.busy} onConfirm={remove.confirm} onClose={remove.close} />
    )}
    <GroupPasteOptionModal
      open={!!paste.groupAsk}
      targetLabel={paste.groupAskLabel}
      memberCount={paste.groupAskMemberCount}
      capacity={paste.groupAskCapacity}
      loading={paste.busy}
      onSelect={paste.onGroupSelect}
      onClose={paste.closeGroupAsk}
    />
    <GroupPastePreviewModal
      open={!!paste.groupPreview}
      targetLabel={paste.groupPreviewLabel}
      results={paste.groupPreview?.results}
      loading={paste.busy}
      onConfirm={paste.onGroupPreviewConfirm}
      onClose={paste.closeGroupPreview}
    />
    <TrainerAssignConfirmModal
      open={!!paste.trainerAsk}
      trainerName={paste.trainerAsk?.trainerName}
      targets={paste.trainerAsk?.targets}
      loading={paste.busy}
      onSelect={paste.onTrainerSelect}
      onClose={paste.closeTrainerAsk}
    />
    <GroupPasteResultModal
      open={!!paste.resultMembers}
      members={paste.resultMembers || []}
      onClose={paste.closeResult}
    />
  </>
);

export default SchedulePasteLayer;
